import React, { useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import gallery1 from "../../assets/banners/gallery1.jpg";
import gallery2 from "../../assets/banners/gallery2.jpg";
import gallery3 from "../../assets/banners/gallery3.jpg";
import gallery4 from "../../assets/banners/gallery4.jpg";
import gallery5 from "../../assets/banners/gallery5.jpg";
import gallery6 from "../../assets/banners/gallery6.jpg";
import gallery7 from "../../assets/banners/gallery7.jpg";
import gallery8 from "../../assets/banners/gallery8.jpg";
import gallery9 from "../../assets/banners/gallery9.jpg";

import "swiper/css";
import "swiper/css/pagination";
import "./css/swiper_style.css";
import { Pagination, Navigation } from "swiper/modules";
import LightboxComponent from "../lightbox/LightboxComponent";
import GalleryReusableHook from "./hooks/GalleryReusableHook";
import { useSelector } from "react-redux";

const SwiperGallery = () => {
  const lightbox_status = useSelector(
    (state) => state.GlobalReducer.lightbox_status
  );
  const { ...param } = GalleryReusableHook();
  const gallery = [
    { img: gallery1, title: "", desc: "" },
    { img: gallery2, title: "", desc: "" },
    { img: gallery3, title: "", desc: "" },
    { img: gallery4, title: "", desc: "" },
    { img: gallery5, title: "", desc: "" },
    { img: gallery6, title: "", desc: "" },
    { img: gallery7, title: "", desc: "" },
    { img: gallery8, title: "", desc: "" },
    { img: gallery9, title: "", desc: "" },
  ];
  return (
    <>
      <Swiper
        slidesPerView={"auto"}
        spaceBetween={20}
        loop={true}
        pagination={{
          clickable: true,
        }}
        modules={[Pagination, Navigation]}
        navigation={true}
        className="mySwiper"
      >
        {gallery.map((image, index) => (
          <SwiperSlide key={index}>
            <img
              src={image.img}
              alt={`Gallery item ${index + 1}`}
              onClick={() => {
                param.openLightbox(true);
              }}
            />
          </SwiperSlide>
        ))}
      </Swiper>

      <LightboxComponent open={lightbox_status} close={param.closeLightbox} />
    </>
  );
};

export default SwiperGallery;
